import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
// import data from '../../assets/data/orders';
import Datatable_Order from '../common/datatable_order'

export class Orders extends Component {
    constructor(props){
        super(props)
        this.state={
            open:true,
            orderList:[0]
        }
    }
    
    componentDidMount(){
        if(!localStorage.getItem('userInfo')){
            window.location.href='/admin';
        }

        fetch(`${process.env['REACT_APP_HOST']}/api/orders/field/`)
        .then(response=>response.json())
        .then(result=>{
            this.setState({orderList:result})   
        })
    }

    render() {
    
        return (
           <Fragment>
                <Breadcrumb title="Orders" parent="Sales" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                {/* <div className="card-header">
                                    <h5>Manage Order</h5>
                                   
                                </div> */}
                                <div className="card-body order-datatable">
                                    
                                <Datatable_Order
                                            multiSelectOption={false}
                                            myData={this.state.orderList}
                                            pageSize={10}
                                            pagination={true}
                                            class="-striped -highlight"
                                        />
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Orders
